import { TextBadge } from '@carvana/ds-badge';
import { decorative } from '@carvana/ds-styles';
import { TrackClick } from '@carvana/merch-components';
import { SectionId } from '~/constants/vdp/section';
import SubSections from '~/constants/vdp/subSections';
import { useIsMobile } from '~/context/common/DeviceContext';
import { useSectionAnalytics } from '~/context/vdp/SectionAnalyticsContext';

export default function GreatDealBadge() {
  const isMobile = useIsMobile();
  const { analyticsAttributes, analyticsId } = useSectionAnalytics();

  return (
    <TrackClick
      className="pointer-events-auto"
      element="a"
      data-adobe-id="great-deal-badge"
      data-analytics-id={analyticsId}
      data-analytics-attributes={{
        ...analyticsAttributes,
        description: 'badge',
        text: 'Great Deal'
      }}
      data-testid="great-deal-tag"
      href={
        isMobile ? `#${SubSections.GreatDeal}` : `#${SectionId.AboutThePrice}`
      }
    >
      <TextBadge
        priority="custom"
        variant="strong"
        customBgColor={decorative.preOrder}
        className="text-text-inverse"
      >
        Great Deal
      </TextBadge>
    </TrackClick>
  );
}
